import React from "react";

import { Button, message, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getRoles,
  reportsApproval,
  updateReportsApproval,
  UpdateReportsApproval,
} from "../../../actions/companySettings";
import { hasAccess, objectToFormData } from "../../../utils";
import PageHeader from "../../PageHeader";
import "./../styles/setting.css";
import HirarchicalApproval from "./HirarchicalApproval";

const { TabPane } = Tabs;

message.config({
  maxCount: 3,
});

const ApprovalReports = () => {
  const dispatch = useDispatch();
  const [reportsApprovalData, setReportsApprovalData] = React.useState([]);
  const [rolesData, setRolesData] = React.useState([]);
  const [selectedRoles, setSelectedRoles] = React.useState([]);
  const reportsApprovalResponse = useSelector(
    (state) => state.companySetting.reportsApproval || {},
  );
  const updateReportsApprovalResponse = useSelector(
    (state) => state.companySetting.updateReportsApproval || {},
  );
  const rolesResponse = useSelector(
    (state) => state.companySetting.getRoles || {},
  );
  const [editMode, setEditMode] = React.useState(false);
  const setTab = () => {};

  React.useEffect(() => {
    dispatch(reportsApproval({}));
    dispatch(getRoles({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const {
      data: { response: { report_approvals = [] } = {}, status = false } = {},
    } = reportsApprovalResponse;
    if (status && report_approvals) {
      setReportsApprovalData(
        report_approvals?.map((ele, idx) => ({ ...ele, level: idx })),
      );
      setSelectedRoles(report_approvals.map((k) => k.role_id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsApprovalResponse]);

  React.useEffect(() => {
    const {
      data: {
        response: { report_approvals = [] } = {},
        status = "",
        message: res_message = "",
        errors = "",
      } = {},
    } = updateReportsApprovalResponse;
    if (status && report_approvals) {
      setReportsApprovalData(
        report_approvals?.map((ele, idx) => ({ ...ele, level: idx })),
      );
      setSelectedRoles(report_approvals.map((k) => k.role_id));
      dispatch({
        type: UpdateReportsApproval.RESET,
      });
      setEditMode(false);
    } else if (status === false) {
      dispatch({
        type: UpdateReportsApproval.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateReportsApprovalResponse]);

  React.useEffect(() => {
    const { data: { response: { roles = {} } = {}, status = false } = {} } =
      rolesResponse;
    if (status) {
      setRolesData(roles);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rolesResponse]);

  const handleSubmit = () => {
    const dataArray = reportsApprovalData.map(
      ({ role_name, id, ...rest }) => rest,
    );
    dispatch(
      updateReportsApproval(
        objectToFormData({ report_approvals: [...dataArray] }),
      ),
    );
  };
  const handleCancel = () => {
    setEditMode(false);
    const filterArray = reportsApprovalData[reportsApprovalData.length - 1];
    if (!filterArray?.role_id) {
      reportsApprovalData.splice(reportsApprovalData.length - 1);
      setReportsApprovalData([...reportsApprovalData]);
    }
  };

  const handleApproveList = (type, key) => {
    if (type === "add") {
      setReportsApprovalData([
        ...reportsApprovalData,
        {
          can_approve_or_reject: false,
          can_reimburse: false,
          id: reportsApprovalData.length,
          level: reportsApprovalData.length,
          role_id: "",
        },
      ]);
    } else {
      const filterArray = reportsApprovalData.filter(
        (obj) => obj.level !== key,
      );
      const updatedArray = filterArray.map(({ level, ...rest }, index) => {
        return { level: index, ...rest };
      });
      setReportsApprovalData([...updatedArray]);
    }
  };

  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`Reports Approval`}
          navigation={{
            Home: "/dashboard/",
            "Reports Approval": null,
          }}
        />
      </div>
      <Tabs onChange={setTab} type="card" size="large" className="custom-tabs">
        <TabPane tab="Hierarchical Approvals" key="preferences">
          <div className="tabContentWrapper">
            <HirarchicalApproval
              approvalData={reportsApprovalData}
              setApprovalData={setReportsApprovalData}
              editMode={editMode}
              handleList={handleApproveList}
              selectedRoles={selectedRoles}
              setSelectedRoles={setSelectedRoles}
              rolesData={rolesData}
            />
            {editMode && (
              <Button
                type="default"
                disabled={!editMode}
                ghost
                className="approve-add-btn mt1"
                onClick={() => handleApproveList("add")}
              >
                + Add one more
              </Button>
            )}
            <div className="floatBottom">
              {!editMode && hasAccess("approvals", "write") && (
                <Button
                  className="formButton mt1 primaryButton"
                  onClick={() => setEditMode(true)}
                >
                  Edit
                </Button>
              )}

              {editMode && (
                <>
                  <Button
                    key="1"
                    className="formButton mt1 primaryButton"
                    onClick={() => handleSubmit()}
                  >
                    Save
                  </Button>
                  <Button
                    key="2"
                    className="cancelButton ml1 mt1"
                    onClick={() => handleCancel()}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </div>
          </div>
        </TabPane>
      </Tabs>
    </>
  );
};

export default ApprovalReports;
